
import { defineComponent, ref } from "vue";
import Checkbox from "primevue/checkbox";
import Button from "primevue/button";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "Layer Popup",
  emits: ["onClosed"],
  setup(props, { emit }) {
    const displayNone7Days = ref(true);

    const { t } = useI18n();

    /**
     * popup 닫기 click event
     */
    const close = () => {
      emit("onClosed", displayNone7Days.value);
    };

    return { displayNone7Days, close, t };
  },
  components: {
    Checkbox,
    Button,
  },
});
